import React from 'react';
import { compose } from 'recompose';
import includes from 'lodash/includes';
import { routesByValue } from 'helpers/routesConstant';
import { withRouter } from 'react-router';
import HeaderContent from 'components/headers/HeaderContent';
import CustomTabs from 'components/Tabs/CustomTabs';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { withFetchStoreTemplates } from 'store/storeTemplates/storeTemplateHocs'
import { withFetchElements } from 'store/elements/elementHocs'
import Sticky from 'components/Sticky'

const CustomPages = compose(
  withRouter,
  muiThemeable(),
  withFetchStoreTemplates(),
  withFetchElements(),
)(
  ({
    router,
    location: { pathname },
    muiTheme: { palette },
    children
  }) => {
    return (
      <div>
        <Sticky>
          {(!includes(pathname, routesByValue.editPage.label) &&
            !includes(pathname, routesByValue.createPage.label)
          ) &&
            <HeaderContent label={routesByValue.pages.label} />
          }
          {(pathname === routesByValue.pages.value ||
            pathname === routesByValue.managePageLocations.value
          ) &&
            <div style={{ backgroundColor: palette.primary1Color }}>
              <CustomTabs
                defaultTabValue={pathname}
                onTouchTab={(value) => router.push(value)}
              >
                <CustomTabs.Tab
                  tabValue={routesByValue.pages.value}
                  tabLabel="Edit Pages"
                  primary
                  size="medium"
                  borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
                />
                <CustomTabs.Tab
                  tabValue={routesByValue.managePageLocations.value}
                  tabLabel="Manage Locations"
                  primary
                  size="medium"
                  borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
                />
              </CustomTabs>
            </div>
          }
        </Sticky>
        {children}
      </div>
    )
  }
)

CustomPages.propTypes = {};
CustomPages.defaultProps = {};

export default CustomPages




// WEBPACK FOOTER //
// ./src/pages/CustomPages/index.js